import { ChatSpotV1HighVolumeApi } from 'ai-components-ui-library/clients/ChatSpotApi';
export const fetchLatestPreview = queryData => {
  return ChatSpotV1HighVolumeApi.get('previews/latest', {
    query: queryData
  });
};